require('jquery-ui/ui/widgets/datepicker');
const validation = require('./extras/validation.js');
const fancybox   = require('@fancyapps/fancybox');

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
	}
});

$.fn.hasAttr = function(name) {
	return this.attr(name) !== undefined;
};

function saveForm(form, errors) {
	var $form = $(form),
		form_id = $form.hasAttr('id') ? $form.attr('id') : false,
		$errors = $(errors),
		$input_links = $('[data-link-input]'),
		action = $form.hasAttr('action') ? $form.attr('action') : '',
		method = $form.hasAttr('method') ? $form.attr('method') : 'post',
		data = $form.serialize();

	$form.find('.blocker').fadeIn(200);
	$form.closest('tr').not(':hidden').fadeTo(200, 0.5);

	return $.ajax({
		url: action,
		type: method,
		data: data,
	})
		.done(function(data) {
			var data_array = $form.serializeArray();
			$.each(data_array, function(index, val) {
				if (val.name.startsWith('_')) { return true; }
				$input_links.filter('[data-link-input="'+val.name+'"]').each(function(index, el) {
					if (form_id && $(el).hasAttr('form')) {
						$(el).filter('[form="'+form_id+'"]').text(val.value);
					} else {
						$(el).text(val.value);
					}
				});
			});
			if (errors.length) {
				$errors.find('.alert_updated')
					.fadeIn(400)
					.removeClass('hide')
					.data('timeout', setTimeout(function() {
						$errors.children().fadeOut('400');
					}, 3500));
			}
		})
		.fail(function(data){
			if (errors.length && typeof data.responseJSON.errors === 'object' && Object.keys(data.responseJSON.errors).length > 0) {
				$.each(data.responseJSON.errors, function(index, val) {
					$errors.append('<div class="alert alert_danger ajax_alert">'+val+'</div>')
						.data('timeout', setTimeout(function() {
							$errors.children().fadeOut('400');
						}, 3500));
				});
			}
		})
		.always(function(data) {
			// console.log(data);
			$form.find('.blocker').fadeOut(200);
			$form.closest('tr').not(':hidden').fadeTo(200, 1);
		});
}

function sendFile(input) {
	var $this = $(input),
		$button = $this.closest('.custom_file'),
		$complete = $button.find('.complete'),
		$input = $button.find('input[type="hidden"]'),
		fd = new FormData(),
		action = $this.attr('data-file-ajax'),
		old_file = $this.hasAttr('data-old') ? $this.attr('data-old') : false,
		i = 0,
		files = $this[0].files,
		len = files.length;
	$complete.css('width', 0).show();
	if (old_file) { fd.append('old_file', old_file); }

	for (; i < len; i++) {
		// console.log("Filename: " + files[i].name);
		// console.log("Type: " + files[i].type);
		// console.log("Size: " + files[i].size + " bytes");
		fd.append('file', files[i]);
	}

	return $.ajax({
		xhr: function() {
			var xhr = new window.XMLHttpRequest();

			xhr.upload.addEventListener("progress", function(evt) {
				if (evt.lengthComputable) {
					var percentComplete = evt.loaded / evt.total;
					percentComplete = parseInt(percentComplete * 100);
					$complete.css('width', percentComplete+'%');

					if (percentComplete === 100) {
						$complete.fadeOut('400');
					}
				}
			}, false);
			return xhr;
		},
		data: fd,
		url: action,
		type: "POST",
		cache: false,
		contentType: false,
		processData: false,
	})
		.done(function(data) {
			$this.wrap('<form>').closest('form').get(0).reset();
			$this.unwrap();
			if (typeof data === 'object') {
				$.each(data, function(index, val) {
					$this.attr('data-old', val);
				});
			}
			$input.val(data);
		})
		.always(function(data) {
			// console.log(data);
		});
}

function consoleImg(url) {
	var image = new Image();

	image.onload = function() {
		var style = [
			'padding: 0 500px;',
			'font-size: 1px;',
			'line-height: 170px;',
			'background-size: auto 100%;',
			'background-image: url('+ url +');',
			'background-repeat: no-repeat;',
			'background-position: top left;',
		].join(' ');
		console.log('%c ', style);
	};
	image.src = url;
};

$('input[name="form"]').each(function(index, el) {
	$(el).val($(this).closest('section').attr('id'));
});

$('img[alt=""]').each(function(){
	var $img = $(this);
	var filename = $img.attr('src');
	var clean = filename.substring((filename.lastIndexOf('/'))+1, filename.lastIndexOf('.')).replace(/([\-\_\+\.]|(min)$)/g, ' ');
	$img.attr('alt', clean);
});

$('a.scroll').click(function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
		var target = $(this.hash);
		var offset = $(this).hasAttr('data-offset') ? $(this).attr('data-offset') : 0;
		target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		if (target.length) {
			$('html,body').animate({
				scrollTop: target.offset().top + parseInt(offset, 10)
			}, 1000);
			return false;
		}
	}
});

// ====== POPUP
$('[data-popup-open]').on('click', function(event) {
	event.preventDefault();
	var $this = $(this),
		sectionid = $this.closest('section').attr('id'),
		popupname = $this.attr('data-popup-open'),
		$popup = $('[data-popup="'+popupname+'"]');

	$popup.removeClass('hidden').fadeTo(400, 1).attr('data-offset', $(document).scrollTop());
	$('body').addClass('popup-shown');
});

$('[data-popup-bg], [data-popup-close], [data-popup-close]').on('click', function(event) {
	event.preventDefault();
	$('body').removeClass('popup-shown');
	if ($(this).closest('[data-popup]').hasAttr('data-offset') && window.innerWidth < 768) {
		$(document).scrollTop($(this).closest('[data-popup]').attr('data-offset'));
	}
	$(this).closest('[data-popup]').fadeTo(400, 0).promise().done(function(){
		$(this).addClass('hidden');
	});
	if ($(this).attr('data-popup-close') == 'reset') {
		setTimeout(function() {
			$('[data-popup-content]').show();
			$('[data-popup-success]').hide();
			$('[data-popup-failed]').hide();
		}, 450);
	}
});

if (lang === 'ru') {
	var dayNames = ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'];
	var dayNamesMin = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
	var dayNamesShort = ['Вск', 'Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Сбт'];
	var monthNames = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
	var monthNamesShort = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'];

	var albumLabel = "";
} else {
	var dayNames = ['Svētdiena', 'Pirmdiena', 'Otrdiena', 'Trešdiena', 'Ceturtdiena', 'Piektdiena', 'Sestdiena'];
	var dayNamesMin = ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'];
	var dayNamesShort = ['Svētd.', 'Pirmd.', 'Otrd.', 'Trešd.', 'Ceturtd.', 'Piektd.', 'Sestd.'];
	var monthNames = ['Janvāris', 'Februāris', 'Marts', 'Aprīlis', 'Maijs', 'Jūnijs', 'Jūlijs', 'Augusts', 'Septembris', 'Oktobris', 'Novembris', 'Decembris'];
	var monthNamesShort = ['Janv.', 'Febr.', 'Marts', 'Apr.', 'Maijs', 'Jūn.', 'Jūl.', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dec.'];
}

$.datepicker.setDefaults({
	firstDay: 1,
	maxDate: '+1y',
	minDate: 'today',
	changeMonth: true,
	dateFormat: 'dd.mm.yy',
	hideIfNoPrevNext: true,
	dayNames: dayNames,
	dayNamesMin: dayNamesMin,
	dayNamesShort: dayNamesShort,
	monthNames: monthNames,
	monthNamesShort: monthNamesShort,
});

$('.datepicker').datepicker();

$.extend($.fancybox.defaults, {
	loop: true,
});
